
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 89.63 89.63"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"d":"M47 74.3a30.75 30.75 0 01-27.53-17 30.61 30.61 0 0112.7-40.68l1.51-.83-.45 1.66a29.23 29.23 0 0041.33 33.8l.69-.37.24-.12L77 50l-.43 1.67a30.74 30.74 0 01-15.9 19.38A30.31 30.31 0 0147 74.3","fill":"none","stroke":"#fff","stroke-miterlimit":"10","stroke-width":"1.31"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M64 26.65a21.41 21.41 0 01-11.16 0 21.41 21.41 0 0111.16 0z"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M58.45 32.23a21.13 21.13 0 010-11.16 21.41 21.41 0 010 11.16zM70.57 11.88a13.24 13.24 0 01-3.35.44 13.24 13.24 0 01-3.35-.44 12.69 12.69 0 016.7 0z"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M67.22 15.23a12.73 12.73 0 010-6.71 12.73 12.73 0 010 6.71zM57.2 10a21.87 21.87 0 01-5.58.74A21.77 21.77 0 0146 10a21.41 21.41 0 0111.2 0z"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M51.62 15.62a21.6 21.6 0 01-.75-5.62 21.6 21.6 0 01.75-5.58 21.87 21.87 0 01.74 5.58 21.87 21.87 0 01-.74 5.62z"}})])
          )
        }
      }
    